import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { PosService } from "src/app/core/services/pos.service";

@Component({
	selector: "app-pos",
	templateUrl: "./pos.component.html",
	styleUrls: ["./pos.scss"],
})
export class PosComponent implements OnInit {
	commandAction: any;

	pendingPrintAction: boolean;

	constructor(public posService: PosService, private route: ActivatedRoute) {}

	ngOnInit(): void {
		const venueKey = +this.route.snapshot.paramMap.get("venueKey");
		this.posService.initPos(venueKey);

		this.posService.venueCommandAction.subscribe((command) => {
			switch (command.command) {
				case "print": {
					this.commandAction = command;
				}
				default: {
					console.log(`venueCommandAction ${command.command} not yet implemented`);
				}
			}
		});
	}
}
